import { gql, useLazyQuery } from '@apollo/client';
import { safeWindowOpen } from '@utils/urlSanitization';
import { Box, Button, Typography, useSnackbar, useTheme } from 'hephaestus/web';
import { Download as DownloadIcon } from 'hephaestus/webIcons';
import { useTranslation } from 'react-i18next';

const FETCH_TRANSFER_SIGNED_FORM_URL = gql`
  query fetchTransferSignedFormURL($manualProcessId: ID!) {
    fetchManualProcess(id: $manualProcessId) {
      manualProcess {
        signedUrl
      }
    }
  }
`;

export const ExternalTransferInManualProcessInfo = ({
  transfer,
}: {
  transfer: any;
}) => {
  const { t } = useTranslation(['components', 'shared']);
  const { enqueueSnackbar } = useSnackbar();
  const theme = useTheme();
  const [fetchFileDocumentUrl] = useLazyQuery(FETCH_TRANSFER_SIGNED_FORM_URL, {
    variables: { manualProcessId: transfer.manualProcess?.id },
    fetchPolicy: 'no-cache',
  });
  const downloadFile = async () => {
    const result = await fetchFileDocumentUrl();
    const url = result?.data?.fetchManualProcess?.manualProcess?.signedUrl;
    if (window && url) {
      // we need setTimeout to open the url in Safari
      setTimeout(() =>
        safeWindowOpen(url, {
          target: '_blank',
          onError: (errorMsg) => {
            enqueueSnackbar(errorMsg, { variant: 'error' });
          },
        }),
      );
    }
  };

  return (
    <Box
      style={{
        padding: '8px 16px',
        borderStyle: 'solid',
        borderWidth: 1,
        borderRadius: theme.borderRadius.lg,
        borderColor: theme.color.outlineVariant,
        marginBottom: '20px',
        display: 'flex',
        justifyContent: 'space-between',
      }}
    >
      <Box>
        <Typography variant='bodyLarge' sx={{ fontWeight: 600 }}>
          {transfer.manualProcess?.transferMethod &&
            t(
              `transferModal.sources.${transfer.manualProcess?.transferMethod}`,
            )}{' '}
          &nbsp;
          {t('transferSources.EXTERNAL_TRANSFER_IN')}
        </Typography>
        <Box
          sx={{
            mt: 1.5,
          }}
        >
          <Typography variant='labelSmall' sx={{ fontWeight: 600 }}>
            {t('transferModal.externalTransfer.relinquishingInstitution')}
          </Typography>
          <Typography variant='bodyLarge'>
            {transfer.manualProcess?.institution?.name}
          </Typography>
        </Box>
        <Box
          sx={{
            mt: 1,
          }}
        >
          <Typography variant='labelSmall' sx={{ fontWeight: 600 }}>
            {t('transferModal.externalTransfer.account')}
          </Typography>
          <Typography variant='bodyLarge'>
            {transfer.manualProcess?.transferAccountNumber}
          </Typography>
        </Box>
      </Box>
      {transfer.manualProcess?.signedUrl && (
        <Box>
          <Button
            variant='contained'
            sx={{
              backgroundColor: `${theme.color.primaryVariant} !important`,
              color: `${theme.color.onPrimaryVariant} !important`,
              width: '195px !important',
              height: '28px !important',
              borderRadius: `${theme.borderRadius.round} !important`,
            }}
            startIcon={<DownloadIcon />}
            onClick={downloadFile}
          >
            {t('transferModal.externalTransfer.signedTransferFormBtnText')}
          </Button>
        </Box>
      )}
    </Box>
  );
};
